import React, { Component } from "react";
import ReactDOM from 'react-dom'; 
import { LangContext } from "../LangContext.jsx";

class IntegerFieldsValidation extends Component {
    constructor(props) {
        super();
        this.state = {
            options:[{
				param:'4',
				description:'Contiene'
				},{
				param:'5',
				description:'No contiene'
				},{
				param:'3',
				description:'Es igual a'
				},{
				param:'9',
				description:'Número de caracteres'
				},{
				param:'1',
				description:'Mayor a'
				},{
				param:'2',
				description:'Menor a'
				}, {
				param:'10',
				description:'Divisa'
            }],
            conditions: [],
        };
    }

    handleAgregarCondicion = (e) => {
        e.preventDefault();  
        const primerElemento = this.state.options[0].param;

        const nuevaCondicion = { param1: primerElemento, param2: ''  };

        this.setState((prevState) => ({
            conditions: [...prevState.conditions, nuevaCondicion],
          		}), () => {
            this.updateValidationState();
        });
    }; 
	handleEliminarCondicion = (index, e, param,description) => {
		e.preventDefault();  
		this.setState((prevState) => {
			const newConditions = prevState.conditions.filter((_, i) => i !== index);  
			return {
				conditions: newConditions,
				options: this.state.options,
			};
		}, () => {
			this.updateValidationState();
		});
	};
    

    handleCondicionChange = (index, campo, valor) => {  
        this.setState((prevState) => {
            const nuevasCondiciones = [...prevState.conditions];
            if (valor == 10) { 
				nuevasCondiciones[index].param2 = 'MXN';
			}
            nuevasCondiciones[index][campo] = valor;
            return { conditions: nuevasCondiciones };
        } ); 
        this.updateValidationState()
    };

    updateValidationState = () => { 
        const allChildStates = { ...this.state }; 
        this.props.updateValidationState(allChildStates);
    }
    componentDidMount() {  
		if (this.props.conditions) {
		let nc = this.props.conditions.map(condition=>{
			return {
			...condition,
			param2: condition.value,
			param1: condition.internal_validation_id,
			};
		}) 
			if (this.props.conditions != null) {
				this.setState({
					conditions: nc, 
				},function(){
					this.updateValidationState() 
				})
			}}
    }
    render() {
        return (
            <div> 
            	{this.state.conditions.map((condition, index) => (
				<div key={index} className="d-flex align-items-center mt-3">
					<div  className="col-md-4" >Campo: {this.props.fieldName}</div>
					<select
					className="form-control"
					value={condition.param1.toString()}
					onChange={(e) => this.handleCondicionChange(index, 'param1', e.target.value)}
					>
					{this.state.options.map((option) => (
						<option key={option.param} value={option.param}>
						{option.description}
						</option>
					))}
					</select> 
					{condition.param1 != '10'  && (
					<input
						className="form-control col-md-5"
						type="text"
						value={condition.param2}
						onChange={(e) => this.handleCondicionChange(index, 'param2', e.target.value)}
					/>
					)} 
					{condition.param1 == '10'  && (
					<select
						className="form-control col-md-5"
						type="text"
						value={condition.param2.toString()}
						onChange={(e) => this.handleCondicionChange(index, 'param2', e.target.value)}
					>
						<option value="MXN">Pesos Mexicanos</option>
						<option value="USD">Dollar</option>
						</select>
					)} 
					<span onClick={(e) => this.handleEliminarCondicion(index, e,condition.param1,condition.description)} className="flaticon2-cross mx-2" style={{ color: '#844AFF' }}></span> 
					
				</div>
				))}
				<div className="d-flex align-items-center cursor-pointer">
					<span className="mt-3 text-primary" onClick={this.handleAgregarCondicion}> <small className="flaticon2-plus text-primary"></small> Agregar nueva condición</span>
				</div>
			</div>
        );
    }
}

export default IntegerFieldsValidation;

if (document.getElementById('IntegerFieldsValidation')) {
    ReactDOM.render(<IntegerFieldsValidation />, document.getElementById('IntegerFieldsValidation'));
}
